import { useRouter } from 'next/router';
import { usersSaysLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import { needTermsCheckLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';

import BannerA from '../components/BannerA';
import FooterTcA from '../components/FooterTcA';
import ListA from '../components/ListA';
import ListB from '../components/ListB';
import SectionA from '../components/SectionA';
import SectionB from '../components/SectionB';

export default function StatusItem() {
    const { locale } = useRouter();

    return (
        <>
            <BannerA />
            <SectionA />
            <ListA />
            <SectionB />
            {!!usersSaysLocales.includes(locale as string) && <ListB />}
            <FooterTcA />
        </>
    );
}
